// extracted by mini-css-extract-plugin
module.exports = {"part-tab":"Tanach-module--part-tab--b4Y5Y","active-part":"Tanach-module--active-part--2Kwrn"};